// extracted by mini-css-extract-plugin
module.exports = {"buscar":"ClienteBuscar_buscar__2E_Bz","combo":"ClienteBuscar_combo__1lTgB"};